import React from 'react';
import ChangeCategoryPositionState from './changeCategoryPositionState/ChangeCategoryPositionState';
import ChangeCategoryPosition from './components/ChangeCategoryPosition';

const ChangeCategoryPositionPage: React.FC = () => {
	return (
		<ChangeCategoryPositionState>
			<ChangeCategoryPosition />
		</ChangeCategoryPositionState>
	);
};

export default ChangeCategoryPositionPage;
